'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardItem = function (_React$Component) {
    (0, _inherits3.default)(DashboardItem, _React$Component);

    function DashboardItem() {
        (0, _classCallCheck3.default)(this, DashboardItem);
        return (0, _possibleConstructorReturn3.default)(this, (DashboardItem.__proto__ || (0, _getPrototypeOf2.default)(DashboardItem)).apply(this, arguments));
    }

    (0, _createClass3.default)(DashboardItem, [{
        key: 'comma',
        value: function comma(num) {
            var source = String(num).split("."); //按小数点分成2部分
            source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,"); //只将整数部分进行都好分割
            return source.join("."); //再将小数部分合并进来
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                count = _props.count,
                className = _props.className,
                itemHeight = _props.itemHeight,
                target = _props.target,
                href = _props.href,
                subtitle = _props.subtitle,
                chartHeight = _props.chartHeight,
                thousandGap = _props.thousandGap,
                chartWidth = _props.chartWidth,
                children = _props.children,
                others = (0, _objectWithoutProperties3.default)(_props, ['title', 'count', 'className', 'itemHeight', 'target', 'href', 'subtitle', 'chartHeight', 'thousandGap', 'chartWidth', 'children']);

            return _react2.default.createElement(
                'div',
                others,
                _react2.default.createElement(
                    'div',
                    { className: 'cn-dash-board-count' },
                    this.renderIconNumber.call(this, thousandGap ? this.comma(count) : count)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cn-dash-board-title' },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cn-dash-board-subtitle' },
                    subtitle
                ),
                children ? _react2.default.createElement(
                    'div',
                    { className: 'cn-dash-borad-chart', style: { width: chartWidth, height: chartHeight } },
                    children
                ) : null
            );
        }
    }, {
        key: 'renderIconNumber',
        value: function renderIconNumber(count) {

            if (count) {
                var arr = [];
                var _count = String(count);
                for (var i = 0, j = _count.length; i < j; i++) {
                    if (_count[i] === ',') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-comma' }));
                    } else if (_count[i] === '%') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-percent' }));
                    } else if (_count[i] === '￥') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-money-ch' }));
                    } else if (_count[i] === '$') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-money-en' }));
                    } else if (_count[i] === '.') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-decimal' }));
                    } else if (_count[i] === '?') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-question' }));
                    } else if (_count[i] === '₽') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-rub' }));
                    } else if (_count[i] === '€') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-eru' }));
                    } else if (_count[i] === '*') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-asterisk' }));
                    } else if (_count[i] === '+') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-plus' }));
                    } else if (_count[i] === '-') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-minus' }));
                    } else if (_count[i] === '<') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-more' }));
                    } else if (_count[i] === '>') {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-less' }));
                        // } else if(/[a-z]/.test(_count[i])) {
                        //     arr.push(<i key={i} className={'dasboard-count num-'+ _count[i]}></i>);
                    } else if (/[0-9]/.test(_count[i])) {
                        arr.push(_react2.default.createElement('i', { key: i, className: 'dasboard-count num-' + _count[i] }));
                    } else {
                        arr.push(_react2.default.createElement(
                            'i',
                            { key: i, className: 'dasboard-count dasboard-custom-count' },
                            _count[i]
                        ));
                    }
                }
                return arr;
            }
        }
    }]);
    return DashboardItem;
}(_react2.default.Component);

DashboardItem.propTypes = {
    count: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    chartWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    chartHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    itemHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    thousandGap: _propTypes2.default.bool,
    src: _propTypes2.default.string,
    target: _propTypes2.default.string
};
DashboardItem.defaultProps = {
    chartWidth: 180,
    chartHeight: 120,
    count: null,
    thousandGap: true,
    title: null,
    subtitle: null,
    src: null,
    itemHeight: null,
    target: '_self'
};
exports.default = DashboardItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-dashboard@0.0.23@@alicd/crui-dashboard/lib/DashboardItem.js
// module id = 617
// module chunks = 0